import { render, staticRenderFns } from "./LifeTwo.vue?vue&type=template&id=73bc1362"
import script from "./LifeTwo.vue?vue&type=script&lang=js"
export * from "./LifeTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports